module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Promo_Tutorial', {
		tutorialGallery: null,
		switchByHash: false,
		swipeGalleryApplied: false,
		
		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				template: 'promo_tutorial',

				'handlers.startSlider': {
					target: '.start',
					event: 'click',
					callback: 'startSlider'
				},
				'handleWom.startSlider': {
					widget: '@this',
					event: 'startSlider',
					callback: 'showSlider'
				},
				'hooks.onAddedToDom': 'actualizeBlocks'
			});

			this.callParent('configure', arguments);
		},

		activate: function () {
			var hash = window.location.hash.replace('#', '');
			
			if (hash.length) {
				this.switchByHash = true;
			}

			window.addEventListener("orientationchange", fox.bind(function() {
				this.applySwipeGallery(true);
			}, this), false);

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			window.removeEventListener("orientationchange");

			this.callParent('deactivate', arguments);
		},

		rendering: function () {
			this.callParent('rendering', arguments);

			if (!this.switchByHash) {
				return;
			};

			var startScreen = fox.dom.selectFirst('.start-screen', this.fragment);
			var slider = fox.dom.selectFirst('.slider-wrap', this.fragment);

			startScreen.style.display = 'none';
			slider.style.display = 'block';
		},

		startSlider: function () {
			this.dispatchEvent('startSlider');
		},

		actualizeBlocks: function () {
			if (!this.switchByHash) {
				return;
			};

			this.dispatchEvent('startSlider');
		},

		showSlider: function () {
			var startScreen = fox.dom.selectFirst('.start-screen', this.element[0]);
			var slider = fox.dom.selectFirst('.slider-wrap', this.element[0]);

			startScreen.style.display = 'none';
			slider.style.display = 'block';

			this.changHeader();
			this.applySwipeGallery();
			
		},

		applySwipeGallery: function (reset) {
			var hash = window.location.hash.replace('#', '');
			var wrap = fox.dom.selectFirst('.slider-wrap', this.element[0]);
			
			if (!wrap) {
				return;
			};

			var pager = fox.dom.selectFirst('.slider-pager', this.element[0]);
			var pagerHover = fox.dom.selectFirst('.hover', pager);
			var block = fox.dom.selectFirst('.slider', wrap);
			var textsBlock = fox.dom.selectFirst('.slider-txt', wrap);
			var arrLt = fox.dom.selectFirst('.arr.lt-arr', wrap);
			var arrRt = fox.dom.selectFirst('.arr.rt-arr', wrap);			
			var slides = fox.dom.select('.item', block);
			var textSlides = fox.dom.select('.item', textsBlock);
			var tmp = document.createDocumentFragment();

			var bullets = [];
			var current = 0;

			var fillPager = function () {
				var w = 0;
				var offset = 0;

				fox.each(bullets, function (foxNode, i) {
					//w = w + $(foxNode.node()).width() - 3;
					if (i <= current) {
						//pagerHover.style.width = w + 'px';
						offset = $(foxNode.node()).position().left + $(foxNode.node()).width() - 4;
						//alert(offset)
						pagerHover.style.width = offset + 'px';
						return;
					};
				}, this);
			};

			var showSlideInfo = function () {
				fox.each(infoSlides, function (node, i) {
					if (i == current) {
						fox.dom.addClass('active', node);
						return;
					};

					fox.dom.removeClass('active', node);
				}, this);
			};

			var showSlideText = function () {
				fox.each(textSlides, function (node, i) {
					if (i == current) {
						fox.dom.addClass('active', node);
						return;
					};

					fox.dom.removeClass('active', node);
				}, this);
			};

			var updateArrows = function () {
				if (current == 0) {
					arrRt.innerHTML = 'Step ' + (current + 2);
					arrLt.innerHTML = '';
					return;
				};

				if (current == (slides.length - 1)) {
					arrRt.innerHTML = 'Registration';
					arrLt.innerHTML = 'Step ' + current;

					fox.dom.addClass('reg', arrRt);
					return;
				}

				arrRt.innerHTML = 'Step ' + (current + 2);
				arrLt.innerHTML = 'Step ' + current;

				fox.dom.removeClass('reg', arrRt);
			};

			var updateHash = function () {
				var hash = '';

				fox.each(slides, function (item, i) {
					if (i == current) {
						hash = item.id.replace(/[a-z]*\-/gi, '');
					}
				}, this);

				console.log(hash);

				window.location.hash = '#' + hash;
			}

			var slideCommonCallback = function () {
				fillPager();
				showSlideText();
				updateArrows();
				updateHash();
			};

			if (reset) {
				current = 0;
				this.tutorialGallery.kill();

				window.tg = this.tutorialGallery = new Swipe(block , {
					continuous: false,
					callback: fox.bind(function(pos, nextItem) {
						current = pos;

						slideCommonCallback();		
					}, this)
				});

				slideCommonCallback();

				return;
			}

			fox.each(slides, function (item, i) {
				bullets[i] = fox.dom.create('span');

				bullets[i].on('click', fox.bind(function () {
					this.tutorialGallery.slide(i);
				}, this));

				bullets[i].addClass('bullet').addClass('blt-' + i);
				tmp.appendChild(bullets[i].node());

				if (hash.length && item.id == 'tutorial-' + hash) {
					current = i;
				}
			}, this);

			window.tg = this.tutorialGallery = new Swipe(block , {
				continuous: false,
				callback: fox.bind(function(pos, nextItem) {
					current = pos;

					slideCommonCallback();
				}, this)
			});

			fox.dom.on('click', arrLt, fox.bind(function () {
				this.tutorialGallery.prev();
			}, this));

			fox.dom.on('click', arrRt, fox.bind(function (e) {
				fox.dom.event.stop(e);

				if (fox.dom.hasClass('reg', arrRt)) {
					fox.site.gotoPage('registration');
					return;
				}

				this.tutorialGallery.next();
			}, this));

			pager.appendChild(tmp);

			if (current) {
				this.tutorialGallery.slide(current);
				return;
			};

			slideCommonCallback();
		},

		// changHeader: function () {
		// 	var header = fox.dom.selectFirst('.promo-header', this.element[0]);

		// 	fox.dom.addClass('slider-header', header);
		// }

	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/promo/tutorial.js
// module id = 471
// module chunks = 2